import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { FloatingSaveShadcnComponent } from 'app/components/floating-save/FloatingSaveShadcnComponent'
import { useUnsavedChangesGuard } from 'app/hooks/useUnsavedChangesGuard'
import { cn } from 'app/lib/utils'
import { AiAgentOverviewSections } from './AiAgentOverviewSections'
import { useAiAgentOverview } from './useAiAgentOverview'
import { SettingsSaveContext, useSettingsSave } from './useSettingsSave'

/**
 * The Settings tab of a practice's Agents: everything about its agent, edited in place. One save
 * bar appears with the first change and saves every section at once.
 */
export const AiAgentMyAgent = observer(function AiAgentMyAgent({ locationId }: { locationId: string }): ReactElement {
  const overview = useAiAgentOverview(locationId)
  const { registry, dirty, blocked, saving, saveAll, discardAll } = useSettingsSave(overview.reload)
  useUnsavedChangesGuard(dirty, `your agent changes`)

  return (
    <SettingsSaveContext.Provider value={registry}>
      <div className={cn(`flex max-w-240 flex-col gap-8`, dirty ? `pb-40` : `pb-16`)}>
        <div className="flex flex-col gap-8">
          <AiAgentOverviewSections locationId={locationId} overview={overview} />
        </div>
      </div>
      <FloatingSaveShadcnComponent
        visible={dirty}
        isSaving={saving}
        buttonType="button"
        buttonLabel="Save Changes"
        onSave={saveAll}
        onDiscard={discardAll}
        disabled={!!blocked}
        description={blocked ?? `Your agent keeps its current settings until you save.`}
      />
    </SettingsSaveContext.Provider>
  )
})
